import { Grid, Typography } from "@mui/material";
import { useMemo } from "react";

import ExecutiveKpiCard from "../ExecutiveKpiCard";
import { buildExecutiveOverviewKpis } from "../utils/buildExecutiveOverviewKpis";

const ExecutiveOverviewKpiRow = ({
  executiveKpis,
  currencyUnit,
  overview,
  growthAnalytics,
  funnelMeta,
  loading,
  error,
  onRetry,
}) => {
  const cards = useMemo(
    () =>
      buildExecutiveOverviewKpis({
        executiveKpis,
        overview,
        growthAnalytics,
        funnelMeta,
      }),
    [executiveKpis, overview, growthAnalytics, funnelMeta]
  );

  return (
    <BoxSection title="شاخص‌های کلیدی مدیریت">
      <Grid container spacing={1.5}>
        {cards.map((item) => (
          <Grid item xs={12} sm={6} md={4} lg={3} key={item.slot}>
            <ExecutiveKpiCard
              kpi={{
                ...item.kpi,
                title: item.title,
                formattedValue: item.kpi?.formattedValue,
              }}
              currencyUnit={currencyUnit}
              loading={loading}
              error={!loading && error && item.source === "missing" ? null : error}
              onRetry={onRetry}
            />
            <Typography variant="caption" color="text.secondary" sx={{ display: "block", mt: 0.5, px: 0.5 }}>
              {item.description}
            </Typography>
          </Grid>
        ))}
      </Grid>
    </BoxSection>
  );
};

const BoxSection = ({ title, children }) => (
  <>
    <Typography fontWeight={700} fontSize={16} sx={{ mb: 1.5 }}>
      {title}
    </Typography>
    {children}
  </>
);

export default ExecutiveOverviewKpiRow;
